define('plugin/facebook-pixel/FacebookPixelPlugin',['require','lib/plugin/PluginAbstract','cookieblock','Config','lib/plugin/PluginBroker','../facebook-pixel/ContentDataFactory'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var CookieBlock = require('cookieblock');
    var Config = require('Config');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var ContentDataFactory = require('../facebook-pixel/ContentDataFactory');

    return PluginAbstract.extend({

        _collection: null,
        fbq: null,
        contentData: {},
        cookiesAccepted: false,
        _thData : null,
        _thTimer : null,
        _thTimeout : 1500,


        initialize: function () {
            this._initFbq();

            Backbone.history.on('route', _.bind(function (){
                this._thAddPageView();
            }, this));

            Backbone.Wreqr.radio.channel('page').vent.on(
                'shown', _.bind(this._thAddPageView, this)
            );
            Backbone.Wreqr.radio.channel('booking').vent.on(
                'step:changed', _.bind(this._thAddPageView, this)
            );

            this.cookiesAccepted = window.cookiesAccepted;
        },

        _initFbq: function (fbq) {
            var _this = this;

            $.cookie('cookies_accepted')
            if (allowCookies) {
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');

                window.fbq('init', Config.getInstance().getOption('tracking_fb_code'));
                // window.fbq('track', 'PageView');

            } else if (!this.cookiesAccepted) {
                CookieBlock.addAcceptedHandler(function () {
                    _this.cookiesAccepted = true;
                    allowCookies = true;
                    _this._initFbq(fbq);
                });

                //NB defer showing cookie block until page (and cookie block in particular) is rendered
                setTimeout(function () {
                    CookieBlock.show();
                });
            }
        },

        _thAddPageView: function (options) {
            var _this = this;

            if (options && options.page){
                this._thData = options;
            }

            if (options && options.step){
                this._thData = {
                    page: 'booking -> ' + options.step,
                }
            }

            clearTimeout(this._thTimer);
            this._thTimer = setTimeout(function (){
                _this._addPageView(_this._thData);
                _this._thData = null;
            }, this._thTimeout);
        },

        _addPageView: function (options) {
            if (window.fbq){
                window.fbq('track', 'ViewContent', {content_name: options.page});
            }
        },

        onFinishBooking : function (data) {
            if(data && data.confirm && window.fbq) {  //booking confirmed
                var invoice = data.invoice;
                var bookingIds = data.booking_ids || [];

                var contentData = {
                    content_ids: bookingIds,
                    transaction_id: (invoice && invoice.get('id')) ? invoice.get('number') : bookingIds.join(','),
                    contents: [],
                };

                _.each(data.bookings.models, function (model) {
                    var service = model.get('service');
                    if(!service){
                        return;
                    }
                    contentData.contents.push({
                        id: service.id,
                        name: service.name,
                        quantity: parseInt(model.get('count')),
                        price: parseFloat(service.price),
                        start_date: model.get('start_date')
                    });

                    contentData.total_quantity = data.bookings.models.length * model.get('count');
                });

                if(data && data.amount){
                    contentData = _.extend(contentData, {
                        currency : data.currency,
                        value : data.amount
                    });
                }

                this.contentData = contentData;
                if ((invoice && invoice.get('id'))) {
                    window.fbq('track', 'InitiateCheckout', contentData);
                } else {
                    window.fbq('track', 'Schedule', contentData);
                }
            }
        },

        onFinishPayment: function(view, data, invoice) {
            if (data.payment_processor != 'delay' && window.fbq) {
                var contentData = {
                    transaction_id: (invoice && invoice.get('id')) ? invoice.get('number') : '',
                    contents: []
                };

                invoice.get('lines').each(function (model) {
                    var contentDataInflator = ContentDataFactory.create(model.get('type'));
                    contentDataInflator.inflate(contentData, model, data);
                });

                 _.extend(contentData, {
                    currency: invoice.get('currency'),
                    value: invoice.get('amount')
                });

                this.contentData = contentData;

                if (!sessionStorage.getItem('transaction_id') || sessionStorage.getItem('transaction_id') !== this.contentData.transaction_id) {
                    sessionStorage.setItem('transaction_id', this.contentData.transaction_id);
                    window.fbq('track', 'Purchase', contentData);
                }
            }
        },
    });

});

